import { combineReducers } from 'redux'
import { INotificationData } from './../types/notification'
import { notifications } from './notificationReducers'

export interface NotificationState {
  notifications: INotificationData[]
}

const notificationApp = combineReducers<NotificationState>({
  notifications
})

export default notificationApp
